import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=351ae35e&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=351ae35e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351ae35e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('351ae35e')) {
      api.createRecord('351ae35e', component.options)
    } else {
      api.reload('351ae35e', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=351ae35e&scoped=true&", function () {
      api.rerender('351ae35e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23mcqioj3ftB1/JS/comp/PopupBox.vue"
export default component.exports